import { isPageAccesible } from './roleHelper';

export const NEWS_PATH = '/news';
export const HOME_PATH = '/home';

// Where "Back" and "Read more" on a shared article should land. Alumni have no
// access to the news pages (see isPageAccesible), so they fall back to home
// rather than bouncing off /access-denied.
export const resolveNewsPath = (roleName?: string | null): string => (
  roleName && !isPageAccesible(NEWS_PATH, roleName) ? HOME_PATH : NEWS_PATH
);

// A redirect target is only ever an in-app path carried in router state — never
// an absolute URL, so the login page cannot be turned into an open redirect.
export const safeRedirectPath = (value: unknown): string => (
  typeof value === 'string' && /^\/(?!\/)/.test(value) ? value : ''
);
